import React, { useState, useContext, useEffect, useRef } from "react";
import "./styles/NewSearch.scss";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import SearchResults from "./SearchResults/SearchResults";
import SearchResultsSkeleton from "./SearchResults/SearchResultsSkeleton";
import SearchNoResult from "../../components/VectorIcons/SearchNoResult";
import AppContext from "../../context/appContext";
import SearchNavigation from "../../components/SearchNavigation/SearchNavigation";
import SearchPagination from "./SearchPagination/SearchPagination";
import ParametersList from "./ParametersList/ParametersList";
import WatermarkGlobal from "../../components/Watermark/Watermark";
import _ from "lodash";

const compileTextResearch = (isParameterized) => {
  let text = {
    contents: {
      title: `Busca por: `,
      mainText: "Nenhum resultado encontrado",
      subText: "Verifique o termo buscado e tente novamente..",
    },
    default: {
      title: "Busca Parametrizada",
      mainText: "Nenhum resultado encontrado com esses parâmetros",
      subText: "Experimente excluir alguns parâmetros e tente novamente.",
    },
  };
  return isParameterized ? text["default"] : text["contents"];
};

const NewSearch = (props) => {
  const appContext = useContext(AppContext);

  const {
    searchList,
    searchTerm,
    filter,
    isParameterized,
  } = appContext;

  const isListLoading = searchList.loading;
  const validSearch = searchList.loading !== "";

  const initialStateReorder = {
    "OrderBy.Column": "",
    "OrderBy.Direction": "",
  };
  const [stateReorder, setStateReorder] = useState(initialStateReorder);

  const searchRef = useRef(null);

  const scrollToTop = () => {
    if (searchRef.current) {
      window.scrollTo({
        top: searchRef.current.offsetTop - 64,
      });
    }
  };

  useEffect(() => {
    scrollToTop();
    // eslint-disable-next-line
  }, [filter.PageNumber]);

  useEffect(() => {
    return () => {
      appContext.setCurrentTerm("");
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Landing directly on /busca (no prior search) triggers the same search as an empty-title button click.
    if (filter === "") {
      appContext.setCurrentTypePath("contents");
      appContext.setCurrentTerm("");
      appContext.setFilterSearch({ term: "", PageNumber: 1, PageSize: 12 });
      appContext.setParameterized(false);
    }
    // eslint-disable-next-line
  }, []);

  const hasParameters = () =>
    Object.values(appContext.filter).some((item) => !_.isEmpty(item) || !!item);

  const currentDirectionType = (bool) => (bool === 0 ? 1 : 0);

  const handleReorderFilter = (reorderType) => {
    const currentDirection = stateReorder["OrderBy.Direction"];
    const isDifferentType = reorderType !== stateReorder["OrderBy.Column"];

    setStateReorder({
      "OrderBy.Column": reorderType,
      "OrderBy.Direction": isDifferentType
        ? 0
        : currentDirectionType(currentDirection),
    });
  };

  useEffect(() => {
    if (!!stateReorder["OrderBy.Column"]) {
      appContext.setFilterSearch({ ...filter, ...stateReorder });
    }
    // eslint-disable-next-line
  }, [stateReorder]);

  useEffect(() => {
    if (!filter["OrderBy.Column"]) setStateReorder(initialStateReorder);
    // eslint-disable-next-line
  }, [filter]);

  return (
    <div id="NewSearch" ref={searchRef}>
      <Breadcrumb>
        <div className="searchHeader">
          <h2 className="searchTitle">
            {compileTextResearch(isParameterized).title}{" "}
          </h2>
          {!isParameterized && <h2 className="searchTerms">{searchTerm}</h2>}
        </div>
      </Breadcrumb>

      {validSearch && (
        <SearchNavigation
          contentTypesHeader={searchList.countsByType}
          loading={!!isListLoading}
        />
      )}

      {!isListLoading ? (
        <WatermarkGlobal>
          <div id="ResultSection">
            <div className="sectionContainer">
              {appContext.isParameterized && (
                <div className="leftContainer">
                  <ParametersList
                    parameters={appContext.filter}
                    hasParameters={hasParameters()}
                  />
                </div>
              )}

              <div className="rightContainer">
                {!!searchList.result.length && (
                  <>
                    <SearchResults
                      list={searchList.result}
                      reorder={stateReorder}
                      handleReorderFilter={handleReorderFilter}
                    />

                    {searchList.pagingInfo.totalPages > 1 && (
                      <SearchPagination pagination={searchList.pagingInfo} />
                    )}
                  </>
                )}
                {validSearch && !searchList.result.length && (
                  <>
                    <div className="noResults">
                      <SearchNoResult />
                      <span className="mainText">
                        {compileTextResearch().mainText}
                      </span>
                      <span className="subText">
                        {compileTextResearch().subText}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </WatermarkGlobal>
      ) : (
        <WatermarkGlobal>
          <div id="ResultSection">
            <div className="sectionContainer">
              {appContext.isParameterized && <div className="leftContainer" />}

              <div className="rightContainer">
                <SearchResultsSkeleton />
              </div>
            </div>
          </div>
        </WatermarkGlobal>
      )}
    </div>
  );
};

export default NewSearch;
